export default __webpack_public_path__ + "static/media/Golden-Snitch-Rigged-03.c8f47c7f.jpg";